import {Component} from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom'

class ContentPanelTextReplace extends Component {

    state = {
        template: this.props.skeleton,
        errorTemplate: this.props.errorTemplate
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        try {
            const response = await fetch(this.props.templateUrl);

            if (response.ok) {
                let htmlContent = await response.text();

                for (let key in this.props.textReplaceMap) {
                    htmlContent = htmlContent.replaceAll(key, this.props.textReplaceMap[key]);
                }

                this.setState({
                    template: ReactHtmlParser(htmlContent)
                });
            } else {
                this.setState({
                    template: this.props.errorTemplate
                })
            }
        } catch (e) {
            this.setState({
                template: this.props.errorTemplate
            })
        }
    };

    render() {
        return (this.state.template)
    }
}

export default withRouter(ContentPanelTextReplace);

ContentPanelTextReplace.propTypes = {
    skeleton: PropTypes.element,
    errorTemplate: PropTypes.element,
    templateUrl: PropTypes.string,
    textReplaceMap: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/ContentPanelTextReplace/ContentPanelTextReplace.js